<template>
    <div id="app">
        <SemcogHeader>
          <span style="line-height: 2em; font-size: 1em;">
            Capital Improvement Projects
          </span>
        </SemcogHeader>
        <MainMap
            v-bind:filter_project_system="filter_project_system"
            v-bind:filter_project_FAC="filter_project_FAC"
            v-bind:filter_project_type="filter_project_type"
            v-bind:filter_start_year="filter_start_year"
            v-bind:filter_end_year="filter_end_year"
            v-bind:filter_cost="filter_cost"
            v-bind:filter_street="filter_street"
            v-bind:start_years="start_years"
            v-bind:end_years="end_years"
            v-bind:project_types="project_types"
        />
        <SideBar
            v-on:input="setFilter($event)"
            v-on:fac="setFACFilter($event)"
            v-bind:start_years="uniqueStartYears"
            v-bind:end_years="uniqueEndYears"
            v-bind:project_types="uniqueProjectTypes"
        />
    </div>
</template>

<script>
    import MainMap from './components/MainMap.vue'
    import SemcogHeader from './components/SemcogHeader.vue'
    import SideBar from "./components/SideBar";

    export default {
        name: 'App',
        components: {
            MainMap,
            SemcogHeader,
            SideBar
        },
        data: function () {
            return {
                filter_project_system: null,
                filter_project_FAC: null,
                filter_project_type: null,
                filter_start_year: null,
                filter_end_year: null,
                filter_cost: [null, null],
                filter_street: null,
                start_years: [],
                end_years: [],
                project_types: [],
            }
        },
        computed: {
            uniqueStartYears: function () {
                return this.getUnique(this.start_years);
            },
            uniqueEndYears: function () {
                return this.getUnique(this.end_years);
            },
            uniqueProjectTypes: function () {
                return this.getUnique(this.project_types);
            }
        },
        methods: {
            setFilter: function (id) {
                if (id[0] === "project_system") {
                    this.filter_project_system = id[1]
                }
                if (id[0] === "project_type") {
                    this.filter_project_type = id[1]
                }
                if (id[0] === "start_year") {
                    this.filter_start_year = id[1]
                }
                if (id[0] === "end_year") {
                    this.filter_end_year = id[1]
                }
                if (id[0] === "project_cost") {
                    this.filter_cost = [id[1], id[2]]
                }
                if (id[0] === "project_street") {
                    this.filter_street = id[1]
                }
            },
          setFACFilter: function (id) {
            if (id[0] === "large_area_id") {
              this.filter_project_FAC = id[1]
            }
          },
            getUnique: function (col) {
                return (Array.from(new Set(col)).sort() || []).map(y => {
                    if (y === null || y === 'N/A') {
                        return {name: 'Missing'}
                    }
                    return {
                        name: y,
                    }
                });
            }
        }
    }
</script>

<style scoped>
    #app {
        width: 100%;
        height: 100vh;
        display: grid;
        grid-template-columns: 70% auto;
        grid-template-rows: max-content auto;
        font-family: Arial, Helvetica, sans-serif;
    }

    @media (max-width: 576px), print {
        #app {
            height: initial;
            grid-template-columns: auto;
            grid-template-rows: max-content max-content auto;
        }
    }
</style>
